 //// Babylon Render Engine 
var slider = document.getElementById("myRange");
var slider2 = document.getElementById("myRange2");

       const sliderheight = document.getElementById("screenheight");
        var sliderheightVal = document.getElementById("screenheightspan");

        var roomnotice = document.getElementById("notice");
        var slidercol3 = document.getElementById("sliderfiller3");


/*var output = document.getElementById("demo");
output.innerHTML = slider.value; // Display the default slider value
*/



var values169;
var values1610;

var leinwandmesh4;
//var shebeammesh;
//var shbeammermesh;


    const button3d = document.getElementById("3db");

if (button3d) {
  button3d.addEventListener("click", showOnly);
}
          
                  document.getElementById("close").addEventListener("click", closeModal);

      const sections = document.querySelectorAll('section');
 var sections1 = document.getElementsByClassName("shopify-section");

  $('.togglebutton').click(function() {
  const $btn = $(this);
  const $panel = $btn.next('.panel'); // nächstes Geschwister-Element
   
  $panel.toggleClass('closed'); // Panel ein-/ausfahren
  $btn.find('.chevron').toggleClass('rotate'); // Chevron drehen
});


function showOnly() {

  for(i=0;i<sections1.length;i++){
    sections1[i].style.display="none";
  }

  // Alle <section>-Elemente ausblenden
  sections.forEach(section => {
    section.style.display = 'none';
  });


  // Das gewünschte Div einblenden
  const selectedDiv = document.getElementById("shopify-section-template--25536884277514__saker_tt_3_d_VERdme");
  if (selectedDiv) {
    selectedDiv.style.display = 'block'; // Das gewählte Div sichtbar machen
    document.getElementById("3dconfig").style.display="block";
  }

  //newParent.appendChild(priceTags);
  
  startRender();
engine.resize();
  

       //startRender();
         window.scrollTo({
        top: 0,
        behavior: "smooth" // smooth scroll, optional
    });

}

        function closeModal() {
   //

  for(i=0;i<sections1.length;i++){
    sections1[i].style.display="";
  }

  // Alle <section>-Elemente ausblenden
  sections.forEach(section => {
    section.style.display = '';
  });


  // Das gewünschte Div einblenden
  const selectedDiv = document.getElementById("shopify-section-template--25536884277514__saker_tt_3_d_VERdme");
  if (selectedDiv) {
    selectedDiv.style.display = 'none'; // Das gewählte Div sichtbar machen
    document.getElementById("3dconfig").style.display="none";
  }
          //oldParent.appendChild(priceTags);
        }
      


/*
  // Alle Elemente im body auswählen
  const allDivs = document.querySelectorAll('body > *');

  allDivs.forEach(div => {
    if (div.id !== '3dconfig') {
      div.style.display = 'none'; // Alle ausblenden, außer das mit der ID '3dconfig'
    }
  });

  // Das gewählte Div einblenden
  const selectedDiv = document.getElementById("3dconfig");
  if (selectedDiv) {
    selectedDiv.style.display = 'block'; // Das gewählte Div einblenden
  }*/


  



const canvas = document.getElementById("renderCanvas"); // Get the canvas element
      const engine = new BABYLON.Engine(canvas, true); // Generate the BABYLON 3D engine

engine.setHardwareScalingLevel(1 / window.devicePixelRatio);

      // Add your code here matching the playground format
      const createScene = function () {
        const scene = new BABYLON.Scene(engine);

      const empty = new BABYLON.TransformNode("emptyParent", scene);
        empty.position.y=2.25;
        empty.rotation = BABYLON.Vector3.Zero();




       
        //const hdrTexture = BABYLON.CubeTexture.CreateFromPrefilteredData("https://assets.babylonjs.com/environments/environmentSpecular.env", scene);
        //scene.environmentTexture = hdrTexture;
        var standardbeambool = false;
        var shortbeambool = false;

        function sleep(ms) {
          return new Promise(resolve => setTimeout(resolve, ms));
        }
   
         values169 = [84, 100, 110, 120, 135, 150, 180];
        values1610 = [106, 120, 135];

        var topDrops=[30,60];

        var tdVal2 = 13.77;
        var oldInd=100;
        var newInd=100;

        var nextpos;

        let debounceTimeout;
      
        
        const sliderValue = document.getElementById('sliderLabel');
        const sliderValue2 = document.getElementById('sliderLabel2');

       // const tDslider = document.getElementById('tDRange');
       // const tDLabel = document.getElementById('tDLabel');

        var tdVal = 13.77;
        var tDheight;
       
        var oldTD = 30;


        /*tDslider.oninput =   function(){
            
          if(selection.Aspect=="r169"){
          tdVal = parseFloat((Number((tDslider.value)/2.54)).toFixed(2));
          tdVal2 = parseFloat(((Number(tDslider.value) + 5) / 2.54).toFixed(2));
          //console.log(tdVal2);
          
          tDLabel.innerHTML = tDslider.value;   
          i= tDslider.value;
          //console.log("oldInd: "+ oldInd);
           tDheight=(oldInd*0.49)+2;
          //console.log(tDheight);
          //(i*0.49) + 13.77) / (62.77)
          //console.log((tDheight+tdVal)/(62.81));

          const tDsliderWidth = tDslider.offsetWidth;
        const tDlabelWidth = tDLabel.offsetWidth;
        const tDnewLeft = ((i - this.min) / (this.max - this.min)) * tDsliderWidth - (tDlabelWidth / 2);
        tDLabel.style.left = `${tDnewLeft}px`;

          leinwandmesh.scaling = new BABYLON.Vector3(newInd/100,(tDheight+tdVal)/(62.77),1);
          leinwandmesh1.scaling = new BABYLON.Vector3(newInd/100,(tDheight+tdVal)/(62.77),1);
          leinwandmesh2.scaling = new BABYLON.Vector3(newInd/100,(tDheight+tdVal)/(62.77),1);
          leinwandmesh4.position.y = -0.40-(0.01*(Number(tDslider.value)-30));

          /*
          if(standardbeambool){
          stbeamermesh.position.y = 1.15*(1-(newInd/99))-(0.01*(Number(tDslider.value)-30));
          stbeammesh.position.y = -0.40-(0.01*(Number(tDslider.value)-30));
        } if(shortbeambool){
          shbeamermesh.position.y = 1.15*(1-(newInd/99))-(0.01*(i-30));
          shbeammesh.position.y = -0.40-(0.01*(i-30));
        }

          oldTD= tDslider.value;
          //console.log("oldTD"+ oldTD);
          
          clearTimeout(debounceTimeout);
          debounceTimeout = setTimeout(async function() {
            
   
            setTD();
            await scaletoTD();
           
        }, 200); // Verzögerung von 300ms //
      }
      if(selection.Aspect=="r1610"){
        tdVal = parseFloat((Number((tDslider.value)/2.54)));
        tdVal2 = parseFloat((Number(tDslider.value) + 5) / 2.54);
        //console.log(tdVal2);
        
        tDLabel.innerHTML = tDslider.value;   
        
        const tDsliderWidth = tDslider.offsetWidth;
        const tDlabelWidth = tDLabel.offsetWidth;
        const tDnewLeft = ((i - this.min) / (this.max - this.min)) * tDsliderWidth - (tDlabelWidth / 2);
        tDLabel.style.left = `${tDnewLeft}px`;


        //console.log("oldInd: "+ oldInd);
         tDheight=(oldInd*0.562)+2;
        //console.log(tDheight);
        //(i*0.49) + 13.77) / (62.77)
        //console.log((tDheight+tdVal)/(66));

        

        leinwandmesh.scaling = new BABYLON.Vector3(newInd*0.00972,(tDheight+tdVal)/(66),1);
        leinwandmesh1.scaling = new BABYLON.Vector3(newInd*0.00972,(tDheight+tdVal)/(66),1);
        leinwandmesh2.scaling = new BABYLON.Vector3(newInd*0.00972,(tDheight+tdVal)/(66),1);
        leinwandmesh4.position.y = -0.40-(0.01*(Number(tDslider.value)-30));

        oldTD= tDslider.value;
        //console.log("oldTD"+ oldTD);
        
        clearTimeout(debounceTimeout);
        debounceTimeout = setTimeout(async function() {
          
        
 
          setTD();
          await scaletoTD();


         
      }, 200); // Verzögerung von 300ms //
    }
     
        } */

   
        var tdVal4;
        var tDheight4;
        var nearestTopDrop = 30;

      
        
        var td10 = document.getElementById("td10");
        var td15 = document.getElementById("td15");
        var td25 = document.getElementById("td25");
        var td30 = document.getElementById("td30");
        var td50 = document.getElementById("td50");
        var td60 = document.getElementById("td60");

        td10.addEventListener("click", buttonTD);
        td15.addEventListener("click", buttonTD);
        td25.addEventListener("click", buttonTD);
        td30.addEventListener("click", buttonTD);
        td50.addEventListener("click", buttonTD);
        td60.addEventListener("click", buttonTD);

        function buttonTD(){
          nearestTopDrop = $(this).attr("value");
        console.log(nearestTopDrop);

        //$("#tdDiv button").prop('disabled', false);
        //$(this).prop('disabled', true);

        $("#tdDiv button").css({
          "background-color": "white",
          "border": "solid 1px grey"
         
        });

        $(this).css({
          "background-color": "white",
          "border-color": "#0071e3",
          "border-width": "2px"
        })

        scaletoTD();

             scaletoTD();

           if(selection.Aspect==="r169"){
          checkSize(newInd,16,9);}
          else if(selection.Aspect==="r1610"){
            checkSize(newInd,16,10);
          }

          if(roombool){

         

            console.log("G "+gesamthöhe*0.01 +"pos "+ empty.position.y)
            if((empty.position.y-(gesamthöhe*0.01))<0){
              console.log("CLIP");
              empty.position.y = 0.01*(gesamthöhe+10);
              screenheightgui(gesamthöhe+10);
            }else if(empty.position.y>(roomHeight.value/100)){
                empty.position.y=(roomHeight.value-20)/100;
                screenheightgui(parseInt(empty.position.y*100));
            }
            else{
              screenheightgui(parseInt(empty.position.y*100));
            }

            checkScreensize();
          }

        }
var titleRecap;

        function getPrice(){
          var currentId= Base.projectorTypes[selection.Beamer][selection.Ambience][selection.Material][selection.Aspect][selection.CaseColor][selection.Size].find(item => item[selection.TopDrop])?.[selection.TopDrop][0];
          selection.ProdVariant=currentId;
           const price = getPriceById(meta, Number(currentId));
                console.log(titleRecap);
            console.log(price);
       var   formattedPrice = (price / 100).toLocaleString("de-DE", { 
    minimumFractionDigits: 2, 
    maximumFractionDigits: 2 
});
   
         console.log(formattedPrice);
         pricehtml.innerHTML = "€"+String(formattedPrice)+" EUR";
         confightml.innerHTML= String(titleRecap);
         
checkVariantAvailability(selection.ProdVariant);     
        }
        
        function getPriceById(product, variantId) {
    const variant = product.product.variants.find(v => v.id === variantId);
          titleRecap = variant.public_title
    return variant ? variant.price : null; 
}

   

       var pricehtml = document.getElementById( "pricehtml");
        var confightml = document.getElementById( "confightml");
        
       async function scaletoTD(){
      
       selection.TopDrop = nearestTopDrop;
         getPrice();
         
        if(selection.Aspect =="r169"){
          //console.log("oldTD"+ oldTD + "new TD "+nearestTopDrop );
          if(oldTD < nearestTopDrop){
            for(let i=oldTD; i< nearestTopDrop;i++){
              //console.log("inside bigger")

              var tdVal3 = parseFloat((Number((i)/2.54)).toFixed(2));
              var tDheight3=(oldInd*0.49)+2;
              //console.log(i+" + "+tdVal3);
              leinwandmesh.scaling = new BABYLON.Vector3(newInd/100,(tDheight3+tdVal3)/(62.77),1);
              leinwandmesh1.scaling = new BABYLON.Vector3(newInd/100,(tDheight3+tdVal3)/(62.77),1);
              leinwandmesh2.scaling = new BABYLON.Vector3(newInd/100,(tDheight3+tdVal3)/(62.77),1);
              leinwandmesh4.position.y = -0.40-(0.01*(i-30))-2.25;

              
              leinwandmesh.rotation = new BABYLON.Vector3(0, 0, 0);
               leinwandmesh1.rotation = new BABYLON.Vector3(0, 0, 0);
               leinwandmesh2.rotation = new BABYLON.Vector3(0, 0, 0);
              leinwandmesh4.rotation = new BABYLON.Vector3(0, 0, 0);
              leinwandmesh5.rotation = new BABYLON.Vector3(0, 0, 0);
              
              /*
              if(standardbeambool){
                stbeamermesh.position.y = 1.15*(1-(newInd/99))-(0.01*(i-30));
                stbeammesh.position.y = -0.40-(0.01*(i-30));
              } if(shortbeambool){
                shbeamermesh.position.y = 1.15*(1-(newInd/99))-(0.01*(i-30));
                shbeammesh.position.y = -0.40-(0.01*(i-30));
              } */

               await sleep(20); 
            }
            

          }

          if(oldTD > nearestTopDrop){
            for(let i=oldTD; i> nearestTopDrop;i--){
              //console.log("inside smaller")
              tdVal = parseFloat((Number((i)/2.54)).toFixed(2));
              tDheight=(oldInd*0.49)+2;

              leinwandmesh.scaling = new BABYLON.Vector3(newInd/100,(tDheight+tdVal)/(62.77),1);
              leinwandmesh1.scaling = new BABYLON.Vector3(newInd/100,(tDheight+tdVal)/(62.77),1);
              leinwandmesh2.scaling = new BABYLON.Vector3(newInd/100,(tDheight+tdVal)/(62.77),1);
              leinwandmesh4.position.y = -0.40-(0.01*(i-30))-2.25;

                       leinwandmesh.rotation = new BABYLON.Vector3(0, 0, 0);
               leinwandmesh1.rotation = new BABYLON.Vector3(0, 0, 0);
               leinwandmesh2.rotation = new BABYLON.Vector3(0, 0, 0);
              leinwandmesh4.rotation = new BABYLON.Vector3(0, 0, 0);
              leinwandmesh5.rotation = new BABYLON.Vector3(0, 0, 0);
              
              /*
              if(standardbeambool){
                stbeamermesh.position.y = 1.15*(1-(newInd/99))-(0.01*(i-30));
                stbeammesh.position.y = -0.40-(0.01*(i-30));
              }
              if(shortbeambool){
                shbeamermesh.position.y = 1.15*(1-(newInd/99))-(0.01*(i-30));
                shbeammesh.position.y = -0.40-(0.01*(i-30));
              }*/

              await sleep(20); 
            }

          }

       
        }

        if(selection.Aspect=="r1610"){

          //(newInd*0.00972,(tDheight+tdVal)/(66),
       
          //console.log("oldTD"+ oldTD + "new TD "+nearestTopDrop );
          if(oldTD < nearestTopDrop){
            for(let i=oldTD; i< nearestTopDrop;i++){

              tdVal4 = parseFloat((Number((i)/2.54)));
              tDheight4=(oldInd*0.562)+2;
            //  console.log("inside bigger")

              var tdVal3 = parseFloat((Number((i)/2.54)).toFixed(2));
              var tDheight3=(oldInd*0.49)+2;
              //console.log(i+" + "+tdVal3);
              leinwandmesh.scaling = new BABYLON.Vector3(newInd*0.00972,(tDheight4+tdVal4)/(66),1);
              leinwandmesh1.scaling = new BABYLON.Vector3(newInd*0.00972,(tDheight4+tdVal4)/(66),1);
              leinwandmesh2.scaling = new BABYLON.Vector3(newInd*0.00972,(tDheight4+tdVal4)/(66),1);
              leinwandmesh4.position.y = -0.40-(0.01*(i-30))-2.25;


                       leinwandmesh.rotation = new BABYLON.Vector3(0, 0, 0);
               leinwandmesh1.rotation = new BABYLON.Vector3(0, 0, 0);
               leinwandmesh2.rotation = new BABYLON.Vector3(0, 0, 0);
              leinwandmesh4.rotation = new BABYLON.Vector3(0, 0, 0);
              leinwandmesh5.rotation = new BABYLON.Vector3(0, 0, 0);
              
              /*

              if(standardbeambool){
                stbeamermesh.position.y = 1.15*(1-(newInd/99))-(0.01*(i-30));
                stbeammesh.position.y = -0.40-(0.01*(i-30));
              }
              if(shortbeambool){
                shbeamermesh.position.y = 1.15*(1-(newInd/99))-(0.01*(i-30));
                shbeammesh.position.y = -0.40-(0.01*(i-30));
              } */
               await sleep(20); 
            }

          }

          if(oldTD > nearestTopDrop){
            for(let i=oldTD; i> nearestTopDrop;i--){

              tdVal4 = parseFloat((Number((i)/2.54)));
              tDheight4=(oldInd*0.562)+2;

             // console.log("inside smaller")
              tdVal = parseFloat((Number((i)/2.54)).toFixed(2));
              tDheight=(oldInd*0.49)+2;

              leinwandmesh.scaling = new BABYLON.Vector3(newInd*0.00972,(tDheight4+tdVal4)/(66),1);
              leinwandmesh1.scaling = new BABYLON.Vector3(newInd*0.00972,(tDheight4+tdVal4)/(66),1);
              leinwandmesh2.scaling = new BABYLON.Vector3(newInd*0.00972,(tDheight4+tdVal4)/(66),1);
              leinwandmesh4.position.y = -0.40-(0.01*(i-30))-2.25;


                       leinwandmesh.rotation = new BABYLON.Vector3(0, 0, 0);
               leinwandmesh1.rotation = new BABYLON.Vector3(0, 0, 0);
               leinwandmesh2.rotation = new BABYLON.Vector3(0, 0, 0);
              leinwandmesh4.rotation = new BABYLON.Vector3(0, 0, 0);
              leinwandmesh5.rotation = new BABYLON.Vector3(0, 0, 0);
              
           /*   if(standardbeambool){
                stbeamermesh.position.y = 1.15*(1-(newInd/99))-(0.01*(i-30));
                stbeammesh.position.y = -0.40-(0.01*(i-30));
              }
              if(shortbeambool){
                shbeamermesh.position.y = 1.15*(1-(newInd/99))-(0.01*(i-30));
                shbeammesh.position.y = -0.40-(0.01*(i-30));
              }*/
              
              await sleep(20); 
            }

          }

        }

           tdVal=parseFloat((Number((nearestTopDrop)/2.54)).toFixed(2));
          tdVal2 = parseFloat(((Number(nearestTopDrop) + 5) / 2.54).toFixed(2));
          oldTD=nearestTopDrop;
          console.log("TDVAL 2 "+tdVal2);

    
      
      }

        var nearestTopDrop;

       

        /*function setTD(){
          var tdsliderVal = tDslider.value;
         // console.log("tdslider "+ tdsliderVal);
          tDslider.min=topDrops[0];
          tDslider.max=topDrops[topDrops.length - 1 ]; 
         
           nearestTopDrop= _.minBy(topDrops, (value) => Math.abs(value - tdsliderVal));

          tDslider.value=nearestTopDrop;
          tDLabel.innerHTML=tDslider.value;
          //console.log("nearest topdrtop: "+nearestTopDrop);

          const tDsliderWidth = tDslider.offsetWidth;
          const tDlabelWidth = tDLabel.offsetWidth;
          const tDnewLeft = ((nearestTopDrop -  tDslider.min) / (tDslider.max -  tDslider.min)) * tDsliderWidth - (tDlabelWidth / 2);
          tDLabel.style.left = `${tDnewLeft}px`;
  

        }
      */

         function setTD(){
           
   $("#tdDiv button").css({
            "background-color": "white",
            "border": "solid 1px grey",
            "display":"none"
          });


       
           
          if (topDrops.includes(String(selection.TopDrop))){
            console.log("ist hte same");
               for (let i = 0; i < topDrops.length; i++) {
            document.getElementById("td"+topDrops[i]).style.display = "inline-block";
              
        }
 document.getElementById("td"+String(selection.TopDrop)).style.border = "solid 1px black";
        getPrice();
            
          }else{
            console.log("not the same");
            for (let i = 0; i < topDrops.length; i++) {
                         

            if(i===0){
              document.getElementById("td"+topDrops[0]).style.border = "solid 1px black";
            }
            document.getElementById("td"+topDrops[i]).style.display = "inline-block";
        }
            setTimeout(() => {
         
           
 $('#tdDiv button:visible').first().trigger('click');
}, "400");   

          }}

         



           
            


        function setTD3(){


       
          $("#tdDiv button").css({
            "background-color": "white",
            "border": "solid 1px grey",
            "display":"none"
          });

          for (let i = 0; i < topDrops.length; i++) {
                         

            if(i===0){
              document.getElementById("td"+topDrops[0]).style.border = "solid 1px black";
            }
            document.getElementById("td"+topDrops[i]).style.display = "inline-block";
        }

        }
        const colors = ['White', 'Black'];

        function getColor() {
            var avColors = Object.keys(Base.projectorTypes[selection.Beamer][selection.Ambience][selection.Material][selection.Aspect]);
            
           // console.log("Farben: " + avColors);
            document.getElementById("White").style.display = "none";
            document.getElementById("Black").style.display = "none";

            

            for (const color of colors) { // Verwendung von 'for...of', um direkt auf die Werte zuzugreifen
                //console.log(color);
                if (avColors.includes(color)) {
                    //console.log(ratio[color]);
                    document.getElementById(color).style.display = "inline-block"; // Anzeigen
                  //  console.log("FOUND: " + color);
                } if (avColors.includes("White")) {
                    setwhiteCase();
                  //setTD();  //12.05
                }
            }
        }

                const tickContainer = document.querySelector('.slider-ticks');


      function getSizes(){


        tickContainer.innerHTML = "";
        
        var avSizes = Object.keys(Base.projectorTypes[selection.Beamer][selection.Ambience][selection.Material][selection.Aspect][selection.CaseColor]);
        console.log(selection);
        console.log("avSizes: "+avSizes);
        values169= avSizes;
      
       //slider2 = document.getElementById("myRange2");
       slider2.min=avSizes[0];
       slider2.max=avSizes[avSizes.length - 1 ]; 

        
       avSizes.forEach(val => {
  const span = document.createElement('span');
  span.textContent = "'";

  // Position in Pixeln berechnen
  const ratio = (val -  slider2.min) / (slider2.max -  slider2.min);
  const posPx = ratio * 346;

  
  span.style.left = `${posPx}px`;

  if(ratio==0){
    span.style.left = `5px`;
  }

  tickContainer.appendChild(span);
});
  

        
       const nearestValue = _.minBy(values169, (value) => Math.abs(value - oldInd));
        
       //topDrops = Base.projectorTypes[selection.Beamer][selection.Ambience][selection.Material][selection.Aspect][selection.CaseColor][nearestValue];
        //console.log(topDrops);

       slider2.value=nearestValue;
       sliderValue.innerHTML=nearestValue;
       selection.Size = nearestValue;


       //oldInd=newInd;
      newInd = Number(nearestValue);
       
        //slider2.dispatchEvent(new Event('input'));

        scale169();

      sliderWidth = slider2.offsetWidth;  // Breite des Sliders
     labelWidth = sliderValue.offsetWidth; // Breite des Labels
     newLeft = ((slider2.value - slider2.min) / (slider2.max - slider2.min)) * sliderWidth - (labelWidth / 2);

sliderValue.style.left = `${newLeft}px`;
  if(newLeft<=0){
         slidercol.style.width="10px"
sliderValue.style.left = `-4px`;
         }else{
          slidercol.style.width=`${newLeft}px`;
         }
        
    
      }


      var slider3 = document.getElementById("myRange3");
      slider3.oninput = function() {
        var i = slider3.value
        sliderValue2.innerHTML = i;
        //console.log(i);

        oldInd= i;
        const sliderWidth3 = this.offsetWidth;
        const labelWidth3 = sliderValue2.offsetWidth;
        const newLeft3 = ((i - this.min) / (this.max - this.min)) * sliderWidth3 - (labelWidth3 / 2);

          sliderValue2.style.left =`${newLeft3}px`;

           if(newLeft3<=0){
         slidercol2.style.width="10px"
             sliderValue2.style.left =`-4px`;
         }else{
          slidercol2.style.width=`${newLeft3}px`;
         }

          gehäusemesh.rotation = new BABYLON.Vector3(0, 0, 0);
          gehäusemesh.scaling = new BABYLON.Vector3(0.00972 * i,1,1);
          gehäusemesh.scaling.x *= -1;

         // console.log("SCLAER;"+ ((i*0.562) + tdVal2));

          leinwandmesh.scaling = new BABYLON.Vector3(0.00972 * i,((i*0.562) + tdVal2) / 66,1);
          leinwandmesh1.scaling = new BABYLON.Vector3(0.00972 * i,((i*0.562) + tdVal2) / 66,1);
          leinwandmesh2.scaling = new BABYLON.Vector3(0.00972 * i,((i*0.562) + tdVal2) / 66,1);
          leinwandmesh4.scaling = new BABYLON.Vector3(0.00972 * i, 0.01079 * i,1);

          leinwandmesh.rotation = new BABYLON.Vector3(0, 0, 0);
              leinwandmesh1.rotation = new BABYLON.Vector3(0, 0, 0);
               leinwandmesh2.rotation = new BABYLON.Vector3(0, 0, 0);
              leinwandmesh4.rotation = new BABYLON.Vector3(0, 0, 0);
              leinwandmesh5.rotation = new BABYLON.Vector3(0, 0, 0);
        
        
          logomesh.position = new BABYLON.Vector3(1.2*(1-(i/106)),-2.25,0);

         /* if(standardbeambool){
            stbeammesh.scaling = new BABYLON.Vector3(0.00972 * i, 0.01079 * i,1);
            stbeammesh.rotation = new BABYLON.Vector3(0, 0, 0);
            stbeamermesh.position = new BABYLON.Vector3(0,1.25*(0.95-(oldInd/99)),0.05);
                }else if(shortbeambool){

                  shbeammesh.scaling = new BABYLON.Vector3(0.00972 * i, 0.01079 * i,1);
                  shbeammesh.rotation = new BABYLON.Vector3(0, 0, 0);
                  shbeamermesh.position = new BABYLON.Vector3(0,1.25*(0.95-(i/99)),0.05);
                }      
*/
              
              const nearestValue = _.minBy(values1610, (value) => Math.abs(value - i));
             // console.log(nearestValue);
           
              
              //clearTimeout(debounceTimeout);
              //debounceTimeout = setTimeout(scale, 200); // Verzögerung von 300ms
              newInd= nearestValue;
              oldInd = i;
              topDrops= Base.projectorTypes[selection.Beamer][selection.Ambience][selection.Material][selection.Aspect][selection.CaseColor][newInd];
              topDrops = topDrops.map(item => Object.keys(item)[0]);
              //setTD();
              
               clearTimeout(debounceTimeout);
                debounceTimeout = setTimeout(function() {

                  slider3.value=newInd;
                  selection.Size = newInd;
                  const newLeft = ((newInd - values1610[0]) / (values1610[values1610.length-1] - values1610[0])) * sliderWidth3 - (labelWidth3 / 2);
                  sliderValue2.innerHTML = newInd;
                //  console.log(newLeft);
sliderValue2.style.left =`${newLeft}px`;

                       if(newLeft<=0){
         slidercol2.style.width="10px"
         sliderValue2.style.left =`-4px`;
         }else{
          slidercol2.style.width=`${newLeft}px`;
         }

                
                  scale1610();
                  setTD();

                  
      
                  
              }, 100); // Verzögerung von 300ms
            
        // console.log("topDrops "+ topDrops);
         // setTD();
         

    }
    var AP = document.getElementById("AcousticPro");
    var CG = document.getElementById("Cinegrey");


      document.getElementById("r1610").addEventListener("click",changeScale1610);

              function changeScale1610(){
            document.getElementById("res169").style.display="none";
            document.getElementById("res1610").style.display="block";
            selection.Aspect="r1610";
             //setwhiteCase()

            $("#r169").prop('disabled', false);
            $("#r1610").prop('disabled', true);

            $("#r169").css({
              "background-color": "",
              "border-color": "",
              "border-width": ""
          });
          
                  $("#r1610").css({
                    "background-color": "white",
                    "border-color": "#0071e3",
                    "border-width": "2px"
                });
          

           AP.style.background="grey";
           AP.disabled=true;
           AP.style.cursor="not-allowed";

            CG.style.background="grey";
            CG.disabled=true;
            CG.style.cursor="not-allowed";
            

              newInd= 120;
              selection.Size=120;
              topDrops= Base.projectorTypes[selection.Beamer][selection.Ambience][selection.Material][selection.Aspect][selection.CaseColor][newInd];
              topDrops = topDrops.map(item => Object.keys(item)[0]);
              console.log(topDrops);
              
              getColor();
              
              console.log(topDrops);
              scale1610();

          
                //oldInd=newInd;
setTimeout(() => {
    setTD();
    console.log("Beide Funktionen wurden aufgerufen.");
}, 1000);
    
          //setTD();
              }
              
                
              
            


            document.getElementById("r169").addEventListener("click", changeScale169 );

              function changeScale169(){
              document.getElementById("res169").style.display="block";
              document.getElementById("res1610").style.display="none";
              selection.Aspect="r169";

              $("#r169").prop('disabled', true);
              $("#r1610").prop('disabled', false);

              $("#r1610").css({
                "background-color": "",
                "border-color": "",
                "border-width": ""
            });
            
                    $("#r169").css({
                      "background-color": "white",
                      "border-color": "#0071e3",
                      "border-width": "2px"
                  });
            

              //newInd=100; 12.5
              //selection.Size=100; 12.5 
              topDrops= Base.projectorTypes[selection.Beamer][selection.Ambience][selection.Material][selection.Aspect][selection.CaseColor][newInd];
              topDrops = topDrops.map(item => Object.keys(item)[0]);
        // console.log("topDrops "+ topDrops);
         // setTD();

          
           AP.style.background="white";
           AP.disabled=false;
           AP.style.cursor="pointer";

            CG.style.background="white";
            CG.disabled=false;
            CG.style.cursor="pointer";
            


              
              getSizes();
              getColor();
              
              //newInd= 100; 
               //setTD();
               scale169(); 
                setTD();
              setTimeout(() => {
    setTD();
    console.log("Beide Funktionen wurden aufgerufen.");
}, 1000); 
                
              }
  


         
             async function scale169() {   

             // console.log("scale169: " +"oldInd:"+oldInd+"newInd: "+newInd);

              
              
              // FORMEL FÜR DIE HÖHE IST ((i*0.49) + 13.77) / (62.77)

              // NEUE GRÖße IN DIAGONAL IN ZOLL * VERHÄLTNISFAKTOR + TOPDROP IN ZOLL / GESAMTHÖHE DER LW IN ZOLL (49+13,77)
             // console.log("inside scale");
              //getColor();
             // console.log("olidn: "+oldInd+"newind: "+ newInd);
             if(oldInd <= newInd){
              for (let i = oldInd; i <= newInd; i++) {   
                console.log("inside for o<n");   
                console.log("tdVAL: "+tdVal);   
                gehäusemesh.scaling = new BABYLON.Vector3(i/100,1,1);
                gehäusemesh.rotation = new BABYLON.Vector3(0, 0, 0);
                gehäusemesh.scaling.x *= -1;
          

                leinwandmesh.scaling = new BABYLON.Vector3(i/100,((i*0.49) + tdVal2) / (62.77),1);
                leinwandmesh1.scaling = new BABYLON.Vector3(i/100,((i*0.49) + tdVal2) / (62.77),1);
                leinwandmesh2.scaling = new BABYLON.Vector3(i/100,((i*0.49) + tdVal2) / (62.77),1);
                leinwandmesh4.scaling = new BABYLON.Vector3(i/100,i/100,1);

                
                leinwandmesh.rotation = new BABYLON.Vector3(0, 0, 0);
                leinwandmesh1.rotation = new BABYLON.Vector3(0, 0, 0);
               leinwandmesh2.rotation = new BABYLON.Vector3(0, 0, 0);
              leinwandmesh4.rotation = new BABYLON.Vector3(0, 0, 0);
              leinwandmesh5.rotation = new BABYLON.Vector3(0, 0, 0);            
                logomesh.position = new BABYLON.Vector3(1.2*(1-(i/100)),-2.25,0);
/*
                if(standardbeambool){
                  stbeammesh.scaling = new BABYLON.Vector3(i/100,i/100,1);
                  stbeammesh.rotation = new BABYLON.Vector3(0, 0, 0);
                   stbeamermesh.position = new BABYLON.Vector3(0,1.15*(1-(i/99)),0.05);
                      } if(shortbeambool){
                        console.log("inside shortbeambool");
                        shbeammesh.scaling = new BABYLON.Vector3(i/100,i/100,1);
                        shbeammesh.rotation = new BABYLON.Vector3(0, 0, 0);
                        //shbeamermesh.position = new BABYLON.Vector3(0,1.6*(1-(i/100)),0.6*(-1+(i/100)));
                      }  */    
                      await sleep(30);       
            }}else if(oldInd > newInd){
              //console.log("inside for o>n");   
              //console.log("tdVAL: "+tdVal);
              for (let i = oldInd; i > newInd; i--) {                                                      
                gehäusemesh.scaling = new BABYLON.Vector3(i/100,1,1);
                gehäusemesh.rotation = new BABYLON.Vector3(0, 0, 0);
                gehäusemesh.scaling.x *= -1;


                leinwandmesh.scaling = new BABYLON.Vector3(i/100,((i*0.49) + tdVal2) / (62.77),1);
                leinwandmesh1.scaling = new BABYLON.Vector3(i/100,((i*0.49) + tdVal2) / (62.77),1);
                leinwandmesh2.scaling = new BABYLON.Vector3(i/100,((i*0.49) + tdVal2) / (62.77),1);
                leinwandmesh4.scaling = new BABYLON.Vector3(i/100,i/100,1);

                leinwandmesh.rotation = new BABYLON.Vector3(0, 0, 0);
                leinwandmesh1.rotation = new BABYLON.Vector3(0, 0, 0);
               leinwandmesh2.rotation = new BABYLON.Vector3(0, 0, 0);
              leinwandmesh4.rotation = new BABYLON.Vector3(0, 0, 0);
              leinwandmesh5.rotation = new BABYLON.Vector3(0, 0, 0);

                logomesh.position = new BABYLON.Vector3(1.2*(1-(i/100)),-2.25,0);

              /*  if(standardbeambool){stbeammesh.scaling = new BABYLON.Vector3(i/100,i/100,1);

                  stbeammesh.rotation = new BABYLON.Vector3(0, 0, 0);
                  stbeamermesh.position = stbeamermesh.position = new BABYLON.Vector3(0,1.15*(1-(i/99)),0.05);
                      }else if(shortbeambool){
                        console.log("inside shortbeambool");
                        shbeammesh.scaling = new BABYLON.Vector3(i/100,i/100,1);
                        shbeammesh.rotation = new BABYLON.Vector3(0, 0, 0);
                        shbeamermesh.position = new BABYLON.Vector3(0,1.15*(1-(i/99)),0.05);

                      } */     
              
                
                      await sleep(30);          
            }

           
            }
       

            oldInd=newInd;
            //console.log("post scale169: " +"oldInd:"+oldInd+"newInd: "+newInd);
            checkColorAv();

               
            if(roombool){

            
          checkSize(newInd,16,9);
        

          console.log("HÖHE:" + (gesamthöhe) + "Breite: " + screenwidth)
          if(gesamthöhe>roomHeight.value ){
              console.log("CLIP HEIGHT");
          } 
            if(screenwidth > roomWidth.value){
            console.log("WIDTH HEIGHT");
          }

          //vom Boden
          if((empty.position.y-(gesamthöhe*0.01))<0){
              console.log("CLIP CHANGE SLIDERVAL");
              empty.position.y = 0.01*(gesamthöhe+10);
               screenheightgui(gesamthöhe+10);
              console.log("HERESLIDERHEIGHT" + sliderheight.value);
            }
            
            // Positioniere LW immer an oberster position 
            if((empty.position.y+20>(roomHeight.value*0.01))){
              //console.log("ZU GROß MACH KLEIN");
              empty.position.y = 0.01*(roomHeight.value-20);
              screenheightgui(roomHeight.value-20);
              //console.log("HERESLIDERHEIGHT" + sliderheight.value);
            }
        
              checkScreensize();
          }


            } 
           var blackbutton = document.getElementById("Black");
           var whitebutton = document.getElementById("White");


           //Prüft ob es die Farbe in der aktuellen größe auch in anders gibt
            function checkColorAv(){

              if (selection.CaseColor == "White") {
                // Optional Chaining nutzen, um auf verschachtelte Objekte zuzugreifen
                var colors = Object.keys(Base.projectorTypes?.[selection.Beamer]?.[selection.Ambience]?.[selection.Material]?.[selection.Aspect]?.['Black'] || {});
                var numcolors = colors.map(color => parseInt(color));
             //   console.log(colors);
             //   console.log(numcolors);

                // Weiter mit dem Code, wenn colors existiert
                if (colors.length === 0) {
                  //  console.error("Keine Farben gefunden.");
                  //  console.log("keine treffer ");
                    return; // Wenn keine Farben vorhanden sind, breche die Funktion ab
                }
        
                for (let i = 0; i < numcolors.length; i++) {
                    let color = colors[i];
                    if (numcolors.includes(Number(newInd))) {
                     //   console.log("Found: " + newInd);  // Falls gefunden
                        blackbutton.style.background = "white";
                        blackbutton.style.cursor = "pointer";
                        blackbutton.disabled = false;

                    }else if (!numcolors.includes(Number(newInd))){
                     // console.log("nicht in der größe da" );
                      blackbutton.style.background = "grey";
                      blackbutton.style.cursor = "not-allowed";
                      blackbutton.disabled = true;

                    }
                }
            }

            if (selection.CaseColor == "Black") {
              // Optional Chaining nutzen, um auf verschachtelte Objekte zuzugreifen
              var colors = Object.keys(Base.projectorTypes?.[selection.Beamer]?.[selection.Ambience]?.[selection.Material]?.[selection.Aspect]?.['White'] || {});
              var numcolors = colors.map(color => parseInt(color));
           //   console.log(colors);
           //   console.log(numcolors);

              // Weiter mit dem Code, wenn colors existiert
              if (colors.length === 0) {
             //     console.error("Keine Farben gefunden.");
             //     console.log("keine treffer ");
                  return; // Wenn keine Farben vorhanden sind, breche die Funktion ab
              }
      
              for (let i = 0; i < numcolors.length; i++) {
                  let color = colors[i];
                  if (numcolors.includes(Number(newInd))) {
               //       console.log("Found: " + newInd);  // Falls gefunden
                      whitebutton.style.background = "white";
                      whitebutton.style.cursor = "pointer";
                      whitebutton.disabled = false;

                  }else if (!numcolors.includes(Number(newInd))){
                 //   console.log("nicht in der größe da" );
                   whitebutton.style.background = "grey";
                   whitebutton.style.cursor = "not-allowed";
                   whitebutton.disabled = true;

                  }
              }
          }
              
            }


        

           





            async function scale1610() {        
              console.log("tdVal: "+tdVal2);     
              if(oldInd <= newInd){
                for (let i = oldInd; i <= newInd; i++) {                                                      
                  gehäusemesh.scaling = new BABYLON.Vector3(0.00972 * i,1,1);
                  gehäusemesh.rotation = new BABYLON.Vector3(0, 0, 0);
                  gehäusemesh.scaling.x *= -1;

  
                  leinwandmesh.scaling = new BABYLON.Vector3(0.00972 * i,((i*0.562) + tdVal2) / 66, 1);
                  leinwandmesh1.scaling = new BABYLON.Vector3(0.00972 * i,((i*0.562) + tdVal2) / 66, 1);
                  leinwandmesh2.scaling = new BABYLON.Vector3(0.00972 * i, ((i*0.562) + tdVal2) / 66, 1);
                  leinwandmesh4.scaling = new BABYLON.Vector3(0.00972 * i, 0.01079 * i, 1);


                  
                  //leinwandmesh.scaling = new BABYLON.Vector3(1,i/108,1); // rescale
                  leinwandmesh.rotation = new BABYLON.Vector3(0, 0, 0);
                       leinwandmesh1.rotation = new BABYLON.Vector3(0, 0, 0);
               leinwandmesh2.rotation = new BABYLON.Vector3(0, 0, 0);
              leinwandmesh4.rotation = new BABYLON.Vector3(0, 0, 0);
              leinwandmesh5.rotation = new BABYLON.Vector3(0, 0, 0);

  
                  logomesh.position = new BABYLON.Vector3(1.2*(1-(i/106)),-2.25,0);
  
                 /* if(standardbeambool){stbeammesh.scaling = new BABYLON.Vector3(0.00972 * i, 0.01079 * i, 1);
  
                    stbeammesh.rotation = new BABYLON.Vector3(0, 0, 0);
                    stbeamermesh.position = new BABYLON.Vector3(0,1.25*(0.95-(i/99)),0.05);
                        }else if(shortbeambool){
  
                          shbeammesh.scaling = new BABYLON.Vector3(0.00972 * i, 0.01079 * i, 1);
                          shbeammesh.rotation = new BABYLON.Vector3(0, 0, 0)
                          shbeamermesh.position = new BABYLON.Vector3(0,1.25*(0.95-(i/99)),0.05);
                        }     */ 
                       await sleep(30);   
              }}else if(oldInd > newInd){
               
                for (let i = oldInd; i > newInd; i--) {                                                      
                  gehäusemesh.scaling = new BABYLON.Vector3(0.00972 * i,1,1);
                  gehäusemesh.rotation = new BABYLON.Vector3(0, 0, 0);
                  gehäusemesh.scaling.x *= -1;

  
                  leinwandmesh.scaling = new BABYLON.Vector3(0.00972 * i, ((i*0.562) + tdVal2) / 66, 1);
                  leinwandmesh1.scaling = new BABYLON.Vector3(0.00972 * i,((i*0.562) + tdVal2) / 66, 1);
                  leinwandmesh2.scaling = new BABYLON.Vector3(0.00972 * i,((i*0.562) + tdVal2) / 66, 1);
                  leinwandmesh4.scaling = new BABYLON.Vector3(0.00972 * i,0.01079 * i, 1);

                  


                      leinwandmesh.rotation = new BABYLON.Vector3(0, 0, 0);
                       leinwandmesh1.rotation = new BABYLON.Vector3(0, 0, 0);
               leinwandmesh2.rotation = new BABYLON.Vector3(0, 0, 0);
              leinwandmesh4.rotation = new BABYLON.Vector3(0, 0, 0);
              leinwandmesh5.rotation = new BABYLON.Vector3(0, 0, 0);
  
                  logomesh.position = new BABYLON.Vector3(1.2*(1-(i/106)),-2.25,0);
  
                /*  if(standardbeambool){stbeammesh.scaling = new BABYLON.Vector3(0.00972 * i, 0.01079 * i, 1);
  
                    stbeammesh.rotation = new BABYLON.Vector3(0, 0, 0);
                    stbeamermesh.position = new BABYLON.Vector3(0,1.25*(0.95-(i/99)),0.05);
                        }else if(shortbeambool){
  
                          shbeammesh.scaling = new BABYLON.Vector3(0.00972 * i, 0.01079 * i, 1);
                          shbeammesh.rotation = new BABYLON.Vector3(0, 0, 0);
                          shbeamermesh.position = new BABYLON.Vector3(0,1.25*(0.95-(i/99)),0.05);
  
                        }    */ 
                
                  
                       
              
               
                 
                       await sleep(30);          
             }
            
             }
             oldInd=newInd;

                  if(roombool){

            
          checkSize(newInd,16,10);
        

          console.log("HÖHE:" + (gesamthöhe) + "Breite: " + screenwidth)
          if(gesamthöhe>roomHeight.value ){
              console.log("CLIP HEIGHT");
          } 
            if(screenwidth > roomWidth.value){
            console.log("WIDTH HEIGHT");
          }

          //vom Boden
          if((empty.position.y-(gesamthöhe*0.01))<0){
              console.log("CLIP CHANGE SLIDERVAL");
              empty.position.y = 0.01*(gesamthöhe+10);
               screenheightgui(gesamthöhe+10);
              console.log("HERESLIDERHEIGHT" + sliderheight.value);
            }
            
            // Positioniere LW immer an oberster position 
            if((empty.position.y+20>(roomHeight.value*0.01))){
              //console.log("ZU GROß MACH KLEIN");
              empty.position.y = 0.01*(roomHeight.value-20);
              screenheightgui(roomHeight.value-20);
              //console.log("HERESLIDERHEIGHT" + sliderheight.value);
            }
        
              checkScreensize();
          }
                 
             }


        function setwhiteCase(){
             selection.CaseColor="White";
              //getPrice();
              scene.getMaterialByName("whiteMetal").albedoColor = BABYLON.Color3.FromHexString("#FFFFFF").toLinearSpace();
              scene.getMaterialByName("Metal").albedoColor = BABYLON.Color3.FromHexString("#FFFFFF").toLinearSpace();
            
              /*
              $("#Black").prop('disabled', false);
              $(this).prop('disabled', true);
  
              $("#Black").css({
                "background-color": "",
                "border-color": "",
                "border-width": ""
            });
            
                    $(this).css({
                      "background-color": "white",
                      "border-color": "black",
                      "border-width": "2px"
                  });
            */

            //getSizes();
              topDrops= Base.projectorTypes[selection.Beamer][selection.Ambience][selection.Material][selection.Aspect][selection.CaseColor][newInd];
              topDrops = topDrops.map(item => Object.keys(item)[0]);
              //12.5  setTD();
              //scaletoTD();
            }
        
            document.getElementById("Black").addEventListener("click", blackCase);
              function blackCase() {
            //  console.log("clicked Black");

              $("#White").prop('disabled', false);
              $(this).prop('disabled', true);
  
              $("#White").css({
                "background-color": "",
                "border-color": "",
                "border-width": ""
            });
            
                    $(this).css({
                      "background-color": "white",
                      "border-color": "#0071e3",
                      "border-width": "2px"
                  });
              
              selection.CaseColor="Black";

              scene.getMaterialByName("whiteMetal").albedoColor = BABYLON.Color3.FromHexString("#000000").toLinearSpace();
              scene.getMaterialByName("Metal").albedoColor = BABYLON.Color3.FromHexString("#000000").toLinearSpace();
              
              
              getSizes();
              topDrops= Base.projectorTypes[selection.Beamer][selection.Ambience][selection.Material][selection.Aspect][selection.CaseColor][newInd];
              topDrops = topDrops.map(item => Object.keys(item)[0]);
              setTD();
              scaletoTD();

            }

            document.getElementById("White").addEventListener("click", whiteCase);
              
              function whiteCase() {

                $("#Black").prop('disabled', false);
                $(this).prop('disabled', true);
    
                $("#Black").css({
                  "background-color": "",
                  "border-color": "",
                  "border-width": ""
              });
              
                      $(this).css({
                        "background-color": "white",
                        "border-color": "#0071e3",
                        "border-width": "2px"
                    });
              

            //    console.log("clicked White");
                selection.CaseColor="White";
              scene.getMaterialByName("whiteMetal").albedoColor = BABYLON.Color3.FromHexString("#FFFFFF").toLinearSpace();
              scene.getMaterialByName("Metal").albedoColor = BABYLON.Color3.FromHexString("#FFFFFF").toLinearSpace();
             
              
              getSizes();
              topDrops= Base.projectorTypes[selection.Beamer][selection.Ambience][selection.Material][selection.Aspect][selection.CaseColor][newInd];
              topDrops = topDrops.map(item => Object.keys(item)[0]);
               setTD();
              scaletoTD();

            }


          //Gehäuse
           var gehäusemesh = BABYLON.AbstractMesh;
          var leinwandmesh = BABYLON.AbstractMesh;
          var logomesh = BABYLON.AbstractMesh;

          gehäuse = BABYLON.SceneLoader.ImportMesh("", "https://cdn.shopify.com/3d/models/6a17798936408540/", "saker-g.glb", scene, function(newMeshes){
             gehäusemesh= newMeshes[0];
            
              gehäusemesh.setParent(empty);
          });

        //leinwand
        
        
       var leinwandmesh; // altes war leinwand4 
        leinwand = BABYLON.SceneLoader.ImportMesh("", "https://cdn.shopify.com/3d/models/1c6a4aefd5caf3b8/", "saker-leinwand.glb", scene, function(newMeshes,particleSystems, skeletons, animationGroups){
           leinwandmesh= newMeshes[2];
           leinwandmesh1= newMeshes[1];
           leinwandmesh2= newMeshes[3];

            leinwandmesh.setParent(empty);
           leinwandmesh1.setParent(empty);
           leinwandmesh2.setParent(empty);

        }); 


        
        leinwandtuch = BABYLON.SceneLoader.ImportMesh("", "https://cdn.shopify.com/3d/models/16cd1ae51fdc50b8/", "saker-tuch.glb", scene, function(newMeshes){
          leinwandmesh4= newMeshes[1];
          leinwandmesh5= newMeshes[0];

          leinwandmesh4.setParent(empty);
          leinwandmesh4.scaling.y = 1;
          leinwandmesh4.rotation = new BABYLON.Vector3(0, 0, 0);
       //   console.log(leinwandmesh4.position.y);

          document.getElementById("CLR").addEventListener("click",changeMat);
           document.getElementById("CLR5").addEventListener("click",changeMat);
          document.getElementById("AcousticPro").addEventListener("click",changeMat);
          document.getElementById("Cinegrey").addEventListener("click",changeMat);
          document.getElementById("MaxWhite").addEventListener("click",changeMat);

          function changeMat(){
 selection.Material=$(this).attr("id");
            
            if(selection.Material==="CLR5"){
                          BABYLON.GLTF2.Loader.Extensions.KHR_materials_variants.SelectVariant(leinwandmesh5,"CLR");

            }else{
            BABYLON.GLTF2.Loader.Extensions.KHR_materials_variants.SelectVariant(leinwandmesh5,$(this).attr("id"));

            }

            
            if(selection.Material==="CLR"){
             // $("#tDLabel").css('left', "-25px");
            }

            //document.getElementById("16:9").style.display="none";
            //document.getElementById("16:10").style.display="none";

            $("#Cinegrey").prop('disabled', false);
        $("#MaxWhite").prop('disabled', false);
        $("#AcousticPro").prop('disabled', false);
        $("#CLR").prop('disabled', false);
         $("#CLR5").prop('disabled', false);
        $(this).prop('disabled', true);
        
        $("#Cinegrey").css({
          "background-color": "",
          "border-color": "",
          "border-width": ""
      });

      $("#MaxWhite").css({
        "background-color": "",
        "border-color": "",
        "border-width": ""
    });

    $("#AcousticPro").css({
      "background-color": "",
      "border-color": "",
      "border-width": ""
  });

  $("#CLR").css({
    "background-color": "",
    "border-color": "",
    "border-width": ""
});

  $("#CLR5").css({
    "background-color": "",
    "border-color": "",
    "border-width": ""
});

        $(this).css({
          "background-color": "white",
          "border-color": "#0071e3",
          "border-width": "2px"
      });

     
           
            getRatios();
           
            console.log("before getsizes");
            getSizes();    
            console.log("after getsizes");
             getColor();
            //setTD(); //12.05
            checkColorAv();
            

            topDrops= Base.projectorTypes[selection.Beamer][selection.Ambience][selection.Material][selection.Aspect][selection.CaseColor][newInd];
            topDrops = topDrops.map(item => Object.keys(item)[0]);
            console.log(topDrops);

            setTimeout(setTD,1000);
      
          //scaletoTD(); 
          


            console.log(selection);
          }
       });
          

       var i;


         function screenheightgui(v){


        const newLeft4 = parseInt(((v - sliderheight.min) /(sliderheight.max - sliderheight.min))*300) ;
        slidercol3.style.width=`${newLeft4}px`;
          sliderheightVal.style.left =`${newLeft4}px`;
          sliderheightVal.innerHTML=v;

       }

        sliderheight.oninput = function(){
          console.log("slider");
          empty.position.y= (0.01*(sliderheight.value)); //.8

    
        sliderheightVal.innerHTML= parseInt(sliderheight.value) ;
        screenheightgui(sliderheight.value);

         
        }

              var slidercol = document.getElementById("sliderfiller");
        var slidercol2 = document.getElementById("sliderfiller2");

       slider2.oninput = function() {
         i = Number(slider2.value);
         sliderValue.innerHTML = i;
         
         oldInd= i;
     //   console.log("TD VAL: "+tdVal2);
     //   console.log("I: "+i);

         const sliderWidth = this.offsetWidth;
           const labelWidth = sliderValue.offsetWidth;
           const newLeft = ((i - this.min) / (this.max - this.min)) * sliderWidth - (labelWidth / 2);
           //console.log(newLeft);

           sliderValue.style.left =`${newLeft}px`;

          if(newLeft<=0){
         slidercol.style.width="10px"
                    sliderValue.style.left =`-4px`;

         }else{
          slidercol.style.width=`${newLeft}px`;
         }

           gehäusemesh.rotation = new BABYLON.Vector3(0, 0, 0);
         gehäusemesh.scaling = new BABYLON.Vector3(i/100,1,1);
         gehäusemesh.scaling.x *= -1;

    //     console.log("I: "+i);    
         //console.log("Rechner: "+parseFloat((i + 13.77) / (113.77)).toFixed(2));
        //      leinwandmesh.scaling = new BABYLON.Vector3(i/100,((i*0.49) + 13.77) / (62.77),1); 

               leinwandmesh.scaling = new BABYLON.Vector3(i/100,((i*0.49) + tdVal2) / (62.77),1);
               leinwandmesh1.scaling = new BABYLON.Vector3(i/100,((i*0.49) + tdVal2) / (62.77),1);
               leinwandmesh2.scaling = new BABYLON.Vector3(i/100,((i*0.49) + tdVal2) / (62.77),1);
               leinwandmesh4.scaling = new BABYLON.Vector3(i/100,i/100,1);


         leinwandmesh.rotation = new BABYLON.Vector3(0, 0, 0);
               leinwandmesh1.rotation = new BABYLON.Vector3(0, 0, 0);
               leinwandmesh2.rotation = new BABYLON.Vector3(0, 0, 0);
              leinwandmesh4.rotation = new BABYLON.Vector3(0, 0, 0);
              leinwandmesh5.rotation = new BABYLON.Vector3(0, 0, 0);
         
               //leinwandmesh.rotation = new BABYLON.Vector3(0, 0, 0);
               //schrauben1.rotation = new BABYLON.Vector3(2, 0, 0);
               //schrauben2.rotation = new BABYLON.Vector3(2, 0, 0);

               logomesh.position = new BABYLON.Vector3(1.2*(1-(i/100)),-2.25,0);


         /*      if(standardbeambool){
                stbeammesh.scaling = new BABYLON.Vector3(i/100,i/100,1);

                 stbeammesh.rotation = new BABYLON.Vector3(0, 0, 0);
                 stbeamermesh.position = new BABYLON.Vector3(0,1.15*(1-(i/99)),0.05);
                 console.log(stbeamermesh.position.y);
                     }else if(shortbeambool){

                       
                      shbeammesh.scaling = new BABYLON.Vector3(i/100,i/100,1);
                       shbeammesh.rotation = new BABYLON.Vector3(0, 0, 0);
                       shbeamermesh.position = new BABYLON.Vector3(0,1.15*(1-(i/99)),0.05);


                     }     
             
*/
               
              
               //console.log(nearestValue);
            
               
               //clearTimeout(debounceTimeout);
               //debounceTimeout = setTimeout(scale, 200); // Verzögerung von 300ms
               
               //5.12 
               
             
               //oldInd=nearestValue;
               //console.log("oldInd danach:"+oldInd);
             
                
               const nearestValue = _.minBy(values169, (value) => Math.abs(value - i));
       newInd= nearestValue;
         selection.Size = nearestValue;
        console.log("nearesT: "+ nearestValue);

       topDrops = Base.projectorTypes[selection.Beamer][selection.Ambience][selection.Material][selection.Aspect][selection.CaseColor][nearestValue];
       topDrops = topDrops.map(item => Object.keys(item)[0]);
       console.log(topDrops);
               //oldInd = i;
               //sliderValue.innerHTML = newInd;
               
       clearTimeout(debounceTimeout);
       debounceTimeout = setTimeout( function() {
         
         
         
         const newLeft = ((newInd - values169[0]) / ((values169[values169.length - 1]) -values169[0])) * sliderWidth - (labelWidth / 2);
        //console.log(newLeft);
        slider2.value=newInd;
        sliderValue.innerHTML = newInd;
         sliderValue.style.left =`${newLeft}px`;

           if(newLeft<=0){
         slidercol.style.width="10px"
                  sliderValue.style.left =`-4px`;

         }else{
          slidercol.style.width=`${newLeft}px`;
         }

         //console.log("SLIDER 2 ");
         //console.log("Slidertest "+"Nearest:"+nearestValue+"oldInd"+oldInd+"newInd"+newInd);
         scale169();

         topDrops= Base.projectorTypes[selection.Beamer][selection.Ambience][selection.Material][selection.Aspect][selection.CaseColor][newInd];
         topDrops = topDrops.map(item => Object.keys(item)[0]);
       //  console.log("topDrops "+ topDrops);
          setTD();
         
         
  /*       
         setTimeout(() => {
           
          if (topDrops.includes(String(selection.TopDrop))){
            console.log("gibt es bereits und ist ausgewählt!")
          }else{
           console.log("necht")
 $('#tdDiv button:visible').first().trigger('click');
}}, "300");
*/
         
         
         

     }, 100); // Verzögerung von 300ms //
               
     //scaletoTD();

     }

       
         //logo
       
         logo = BABYLON.SceneLoader.ImportMesh("", "https://cdn.shopify.com/3d/models/08f2bb9dee0d9b6b/", "saker-logo.glb", scene, function(newMeshes){
          logomesh= newMeshes[0];
           logomesh.setParent(empty);
       //   console.log(logomesh.position.x)
       });
      

       
     
      
      

        const camera = new BABYLON.ArcRotateCamera("camera", -Math.PI / 2, Math.PI / 2.5, 15, new BABYLON.Vector3(0, 0, 0));
        camera.attachControl(canvas, true);
        camera.setPosition(new BABYLON.Vector3(0, -0.5,4));
        camera.target = new BABYLON.Vector3(0 ,-0.75,0);
        const light = new BABYLON.HemisphericLight("light", new BABYLON.Vector3(0, 1, 1));

         const pointLight = new BABYLON.PointLight("point", new BABYLON.Vector3(0, 0, -5), scene);
        pointLight.intensity = 0.4;
        
      
        camera.wheelPrecision = 70;
        camera.lowerRadiusLimit=1;
        camera.minZ = 0;

       var bGchange = document.getElementById("mainelement");

        
      // Füge die Animation der Kamera hinzu
      document.getElementById("Dark").addEventListener("click",async () => {


      
        $("#Dark").prop('disabled', true);
        $("#Bright").prop('disabled', false);

        $("#Bright").css({
          "background-color": "",
          "border-color": "",
          "border-width": ""
      });

        $("#Dark").css({
          "background-color": "white",
          "border-color": "#0071e3",
          "border-width": "2px"
      });
        //scene.clearColor = new BABYLON.Color4(0.3, 0.3, 0.3, 1);
        await sleep(10); 


        for(let i=1; i< 25; i++){
          var cVal = 100-i;
          scene.clearColor = new BABYLON.Color4(cVal/100, cVal/100, cVal/100, 1);
          bGchange.style.background = "rgb(" + cVal + "% " + cVal + "% " + cVal + "%)";

           if(roombool){
          wallMaterial.specularPower = 2.56*i;
          } 
          pointLight.intensity = 0.4-(0.016*i); 
          
          await sleep(10); 

        }

      });

      document.getElementById("Bright").addEventListener("click",async () => {

      //var buttony=  console.log(Base[selection.Beamer][selection.Ambiance][0])

        const event = new Event("click", { bubbles: true, cancelable: true });
        document.getElementById(avMaterials[0]).dispatchEvent(event);

        $("#Bright").prop('disabled', true);
        $("#Dark").prop('disabled', false);


        $("#Dark").css({
          "background-color": "",
          "border-color": "",
          "border-width": ""
      });

        $("#Bright").css({
          "background-color": "white",
          "border-color": "#0071e3",
          "border-width": "2px"
      });
        

        //scene.clearColor = new BABYLON.Color4(0.3, 0.3, 0.3, 1);
        await sleep(10); 


        for(let i=1; i< 25; i++){
          var cVal2 = 75+i
          scene.clearColor = new BABYLON.Color4(cVal2/100, cVal2/100, cVal2/100, 1);         
          bGchange.style.background = "rgb(" + cVal2 + "% " + cVal2 + "% " + cVal2 + "%)";
          if(roombool){
            wallMaterial.specularPower = 64-(2.56*i);
                    }
          pointLight.intensity = 0.016*i;
          await sleep(10); 

        }

      });
     
     /* document.getElementById("removebeamer").addEventListener("click",removeB);

      function removeB(){
        camera.setPosition(new BABYLON.Vector3(0, -1,4));
        camera.target = new BABYLON.Vector3(0 ,-0.5,0);
        if(shortbeambool){
          shbeamermesh.dispose();
        shbeammesh.dispose();
        shortbeambool = false;
        }else if(standardbeambool){
          if(standardbeambool){
            stbeamermesh.dispose();
          stbeammesh.dispose();
          standarbeambool = false;
          }
        }
      } */

        //Beamer
       document.getElementById("Standard-Throw").addEventListener("click",selectStandardBeamer);

       function selectStandardBeamer(){
        console.log("NewInd:"+ newInd+"oldInd: "+ oldInd);
        selection.Beamer= $(this).attr("id");
        $("#r1610").css("display", "");

        const event = new Event("click", { bubbles: true, cancelable: true });
        document.getElementById("MaxWhite").dispatchEvent(event);

        $("#Standard-Throw").prop('disabled', true);
        $("#Short-Throw").prop('disabled', false);
        
        $("#Short-Throw").css({
          "background-color": "",
          "border-color": "",
          "border-width": ""
      });

        $(this).css({
          "background-color": "white",
          "border-color": "#0071e3",
          "border-width": "2px"
      });
        

        
    //    console.log(selection.Beamer);
        getMaterials();
        
      /*  if(shortbeambool){
          shbeamermesh.dispose();
        shbeammesh.dispose();
        }
*/
        standardbeambool = true;
        shortbeambool = false;

       /* stbeam = BABYLON.SceneLoader.ImportMesh("", "assets/3D/", "beam22.glb", scene, function(newMeshes){
          stbeammesh= newMeshes[1];
           camera.setPosition(new BABYLON.Vector3(-5, -1,0.4));
           camera.setTarget(new BABYLON.Vector3(0, -1,2));
         
       

          stbeammesh.scaling = new BABYLON.Vector3(newInd/100,newInd/100,1);

          stbeammesh.rotation = new BABYLON.Vector3(0, 0, 0);
          console.log("Y KOORD:"+stbeammesh.position.y); 
          
       });

       stbeamer = BABYLON.SceneLoader.ImportMesh("", "assets/3D/", "standardBeamer-v1.glb", scene, function(newMeshes){
        stbeamermesh= newMeshes[0];
         //camera.setPosition(new BABYLON.Vector3(-5, -1,0.4));
         //camera.setTarget(new BABYLON.Vector3(0, -1,2));
        //stbeamermesh.position = new BABYLON.Vector3(0,1.15*(1-(newInd/99)),0.05);
        stbeamermesh.position.y= -0.5;
       console.log("Y_POS "+stbeamermesh.position.y);
        
     });
*/

       }
      
       document.getElementById("Short-Throw").addEventListener("click",selectShortBeamer);

       function selectShortBeamer(){

        /*shbeam = BABYLON.SceneLoader.ImportMesh("", "assets/3D/", "beam12.glb", scene, function(newMeshes){
          shbeammesh= newMeshes[1];
          //camera.setPosition(new BABYLON.Vector3(-5, -1,0.4));
          //camera.setTarget(new BABYLON.Vector3(0, -1,2));
        
         // newpivot = leinwandmesh4.getPivotPoint();
         // shbeammesh.setPivotPoint(new BABYLON.Vector3(0, 0, 0));
        
          shbeammesh.scaling = new BABYLON.Vector3(newInd/100,newInd/100,1);
          shbeammesh.rotation = new BABYLON.Vector3(0, 0, 0);
          shortbeambool = true;
          standardbeambool = false;
        });*/

            shortbeambool = true;
          standardbeambool = false;
        
        /*shbeamer = BABYLON.SceneLoader.ImportMesh("", "assets/3D/", "shortBeamer-v2.glb", scene, function(newMeshes){
        shbeamermesh= newMeshes[0];
        //camera.setPosition(new BABYLON.Vector3(-5, -1,0.4));
         //camera.setTarget(new BABYLON.Vector3(0, -1,2));
        shbeamermesh.position = new BABYLON.Vector3(0,1.15*(1-(newInd/99)),0.05);
        
        
        }); */
        
          console.log("NewInd:"+ newInd+"oldInd: "+ oldInd);

           newInd =100;
          selection.Size= 100;
          selection.Aspect= "r169";

        selection.Beamer= $(this).attr("id");
        selection.Material= "CLR";
        $("#r1610").css("display", "none");
        $("#res1610").css("display", "none");
        $("#res169").css("display", "");

        $("#Standard-Throw").prop('disabled', false);
        $("#Short-Throw").prop('disabled', true);

       
        $("#Standard-Throw").css({
          "background-color": "",
          "border-color": "",
          "border-width": ""
      });

      $("#r169").css({
        "background-color": "white",
        "border-color": "#0071e3",
        "border-width": "2px"
    });
        $(this).css({
          "background-color": "white",
          "border-color": "#0071e3",
          "border-width": "2px"
      });

           const event = new Event("click", { bubbles: true, cancelable: true });
        document.getElementById("CLR").dispatchEvent(event);
        
     //   console.log(selection.Beamer);
     getMaterials();
     //getColor();
     //getSizes();
     //setTD(); //12.05    
     /*topDrops= Base.projectorTypes[selection.Beamer][selection.Ambience][selection.Material][selection.Aspect][selection.CaseColor][newInd];
     setTD();
     scaletoTD();*/

       //scale169();

      /*  if(standardbeambool){
          stbeamermesh.dispose();
        stbeammesh.dispose();
        }*/
        

        
      
  console.log(newInd);
     
   

      }



      //ROOMSTART

        //getSizes();
  //ROOM

          var mainWall; 
    var roombool;
         var wallMaterial;

    function createRoom(){
         $('#roomgui').toggleClass('panel');
          $('#roomgui').removeClass('roomguic');
 document.getElementById("createRoom").style.display="none";
      
      roombool=true;
      if(selection.Aspect==="r169"){
          checkSize(newInd,16,9);}
          else if(selection.Aspect==="r1610"){
            checkSize(newInd,16,10);
          }
        
          

        wallMaterial = new BABYLON.StandardMaterial("wallMat", scene);
        wallMaterial.diffuseColor = new BABYLON.Color3(1, 1, 1);
        wallMaterial.roughness=0;
        wallMaterial.specularColor = new BABYLON.Color3(0.1, 0.1, 0.1); // weniger Glanz
        
      if(selection.Ambience=="Dark"){wallMaterial.specularPower = 64;}else{
        wallMaterial.specularPower = 0;
      } // glatterer Glanzpunkt

        const floorMaterial = new BABYLON.StandardMaterial("floorMat", scene);
        var  texture = new BABYLON.Texture("https://cdn.shopify.com/s/files/1/0568/2806/8035/files/floor.webp?v=1752150856", scene);

        floorMaterial.diffuseTexture =  texture;
        //floorMaterial.specularColor = new BABYLON.Color3(0.1, 0.1, 0.1);

      

        // Maße
        var wallWidth = 0.01*(screenwidth+100);
        console.log(wallWidth);
        var wallHeight = 0.01*(gesamthöhe+100);
        var wallDepth = 0.01;


        // Setze interface mit beschränkungen
          roomHeight.value=parseInt(gesamthöhe)+100;
          roomWidth.value=parseInt(screenwidth)+100;
        //

        var floorWidth = wallWidth;
        var floorLength = wallWidth + wallDepth;
        // Hauptwand (Front)
         mainWall = BABYLON.MeshBuilder.CreateBox("mainWall", {
            width: 1,
            height: 1,
            depth: 0.01
        }, scene);
        //mainWall.position = new BABYLON.Vector3(0, -3, 0);
        mainWall.material = wallMaterial;
        mainWall.setPivotPoint(new BABYLON.Vector3(0, -1 / 2, 0));

        // Linke Wand
        const leftWall = BABYLON.MeshBuilder.CreatePlane("floor", {width: 1, height: 1}, scene);

        leftWall.rotation.y = 1.5*Math.PI;
        // position x = -halbe Wandbreite, z = -halbe Wandbreite (links hinten)
        leftWall.position = new BABYLON.Vector3(-1 / 2, 0, -1 / 2);
        leftWall.material = wallMaterial;

        // Rechte Wand
        const rightWall = BABYLON.MeshBuilder.CreatePlane("floor", {width: 1, height: 1}, scene);
        rightWall.rotation.y = Math.PI / 2;
        // position x = +halbe Wandbreite, z = -halbe Wandbreite (rechts hinten)
        rightWall.position = new BABYLON.Vector3(1 / 2, 0, -1 / 2);
        rightWall.material = wallMaterial;

        // Boden als Plane genau passend in den Raum
        // Breite = wallWidth (zwischen linken und rechten Wand-Innenkanten)
        // Länge = wallWidth + Wanddicke (von Frontwand bis Rückseite der Seitenwände)
        // etwas tiefer als Seitenwand Tiefe

        const floor = BABYLON.MeshBuilder.CreatePlane("floor", {width: 1, height: 1}, scene);
        floor.rotation.x = Math.PI / 2; // flach auf Boden
        // positioniert unterhalb der Wände:
        // Y = 0 (Boden)
        // Z = -(floorLength / 2) + Wanddicke/2 (damit es unter Frontwand und zwischen Seitenwänden liegt)
        floor.position = new BABYLON.Vector3(0, -1/2, -1.01 / 2 + 0.01 / 2);
        floor.material = floorMaterial;

        // Parenting
        leftWall.parent = mainWall;
        rightWall.parent = mainWall;
        floor.parent = mainWall;

        
        mainWall.rotation.y=Math.PI;
        mainWall.position.y=-1.75;
        mainWall.position.z=-0.065;

        mainWall.scaling.x=wallWidth;
        mainWall.scaling.y=wallHeight;
         mainWall.scaling.z=3;

      sliderheight.min = gesamthöhe+10;
      sliderheight.max= (100*wallHeight)-20;

        
            if((empty.position.y-(gesamthöhe*0.01))<0){
              console.log("CLIP");
              empty.position.y = 0.01*(gesamthöhe+10);
              screenheightgui(gesamthöhe+10);
            }
          

     }
    
    

//createRoom();
        //Skaliere Raum:
        console.log("TEST");
        document.getElementById("createRoom").addEventListener("click",createRoom);
    //WAND ENDE


    document.getElementById("removeRoom").addEventListener("click",deleteRoom);

    function deleteRoom(){
       roombool=false; 
          mainWall.dispose();
           $('#roomgui').removeClass('panel');
          $('#roomgui').toggleClass('roomguic');
       document.getElementById("createRoom").style.display="flex";
    }

    document.getElementById("updateRoom").addEventListener("click",updateRoom );

      
     const roomHeight = document.getElementById("roomheight");
  const roomWidth = document.getElementById("roomwidth");

    function updateRoom(){
       
  const roomHeightval =roomHeight.value;
  const roomWidthval = roomWidth.value

      console.log(roomWidthval/screenwidth+100);
          //mainWall.scaling.y = (0.01*roomHeightval)/2.4
 if (
  !isNaN(roomHeightval)
 && roomHeightval >= 220 && roomHeightval <= 600 
 
) {
  mainWall.scaling.y = roomHeightval/100;
  console.log("Raumhöhe:", roomHeightval, "cm");

   sliderheight.max= roomHeightval-20;

 // wenn gesamtgröße >als wand dann färbe leinwand rot, wenn gesamtgröße < wand dann platziere ganz oben
 console.log("G"+gesamthöhe + "roomheight "+ roomHeightval);

  if(selection.Aspect==="r169"){
          checkSize(newInd,16,9);}
          else if(selection.Aspect==="r1610"){
            checkSize(newInd,16,10);
          }

 if((parseInt(empty.position.y*100))>roomHeightval){
  console.log("clipeprcheck");
    empty.position.y=(sliderheight.max/100);
    screenheightgui(sliderheight.max);
    /*sliderheightVal.innerHTML=sliderheight.max;
    sliderheight.value=sliderheight.max; */
 }else{
 
screenheightgui(parseInt(empty.position.y*100));
 }
  
}else{
    console.log("Please enter a wall height between 220 cm and 600 cm");

  alert("Please enter a wall height between 220 cm and 600 cm");

}

 if(!isNaN(roomWidthval) &&  roomWidthval >= 240 && roomWidthval <= 1000){
  mainWall.scaling.x = roomWidthval/100;
  console.log("Raumhöhe:", roomHeightval, "cm");

   sliderheight.max= roomHeightval-20;

 // wenn gesamtgröße >als wand dann färbe leinwand rot, wenn gesamtgröße < wand dann platziere ganz oben
 console.log("G"+gesamthöhe + "roomheight "+ roomHeightval);

  if(selection.Aspect==="r169"){
          checkSize(newInd,16,9);}
          else if(selection.Aspect==="r1610"){
            checkSize(newInd,16,10);
          }

 if((parseInt(empty.position.y*100))>roomHeightval){
  console.log("clipeprcheck");
    empty.position.y=(sliderheight.max/100);
    screenheightgui(sliderheight.max);
    /*sliderheightVal.innerHTML=sliderheight.max;
    sliderheight.value=sliderheight.max; */
 }else{
 
screenheightgui(parseInt(empty.position.y*100));
 }

 }else{ 
  console.log("Please enter a wall width between 240 cm and 1000 cm");
  alert("Please enter a wall width between 240 cm and 1000 cm");}

 
checkScreensize();
 
    }

    var gesamthöhe;
    var screenwidth;

      function checkSize(diagonalInInches, ratioWidth, ratioHeight){

        console.log("TD: "+nearestTopDrop + "NewInd"+newInd);

        var factor = Math.sqrt(ratioWidth ** 2 + ratioHeight ** 2);

        


        //var widthInInches = diagonalInInches * (ratioWidth / factor);
        var heightInInches = diagonalInInches * (ratioHeight / factor);

        screenwidth = 264* (diagonalInInches/100);
        var screenheight = heightInInches * 2.54;

         gesamthöhe = parseInt(screenheight + 6 + Number(nearestTopDrop) + 10);
        console.log("Berechnung: height"+ screenheight + "neearest TD: "+ nearestTopDrop);

        //sliderheight.max=gesamthöhe+80;
        sliderheight.min = gesamthöhe+10;

        //wenn wir ein kleineres tD größer machen, dann muss es auf das neue min springen automatisch
        // -> if 

        console.log("Breite: "+ screenwidth);
        console.log("Höhe: "+ gesamthöhe );

        //sliderheight.max= gesamthöhe+80;

      }

      //document.getElementById("checksizing").addEventListener("click",checkSize(newInd,16,9));

      
      function checkScreensize(){
console.log("SCREENSIZE"),
//console.log("Zu Hoch. LW "+gesamthöhe +" Raum:  " +roomHeight.value )
// console.log("Zu Breit. LW "+screenwidth +" Raum:  " +roomWidth.value )
roomnotice.style.display="none";


if(gesamthöhe+20>roomHeight.value){
  console.log("Zu Hoch. LW "+gesamthöhe +" Raum:  " +roomHeight.value )
  roomnotice.style.display="flex";
}

if(screenwidth>roomWidth.value){
 console.log("Zu Breit. LW "+screenwidth +" Raum:  " +roomWidth.value )
  roomnotice.style.display="flex";
}
      }


         // ROOMEND

    
        //scene.debugLayer.show();
        return scene;
      };

      
    
      function startRender(){
      const scene = createScene(); //Call the createScene function
      scene.clearColor = new BABYLON.Color4(0.75, 0.75, 0.75, 1);
      //engine.resize();

      // Register a render loop to repeatedly render the scene
      engine.runRenderLoop(function () {
        scene.render();
      });

      // Watch for browser/canvas resize events
      window.addEventListener("resize", function () {
        engine.resize();
      })
    }

var butAddC = document.getElementById("addCart");
      
            function checkVariantAvailability(variantId) {
  fetch(`/variants/${variantId}.js`)
    .then(res => res.json())
    .then(variant => {
      if (variant.available) {
        console.log('Variante verfügbar ✅');
        butAddC.innerHTML="Add to cart"
        butAddC.classList.remove('disabled');
        butAddC.disabled=false;
        // Hier Button aktivieren
        //document.querySelector('#add-to-cart-button').disabled = false;
      } else {
        console.log('Variante NICHT verfügbar ❌');
        butAddC.innerHTML="Sold out"
       butAddC.disabled=true;
        butAddC.classList.add('disabled');
        // Hier Button deaktivieren
        //document.querySelector('#add-to-cart-button').disabled = true;
      }
    })
    .catch(err => {
      console.error('Fehler beim Prüfen der Variante:', err);
    });
}


  //startRender();
    

      //startRender();
    

      document.getElementById("canvas-style").addEventListener("click", startEngine, { once: true })
  document.getElementById("canvas-style").addEventListener("touchstart",startEngine, { once: true });
    
  function startEngine(){
document.getElementById("poster").style.display="none";
  }